import { render, staticRenderFns } from "./RegattaLink.vue?vue&type=template&id=3542e0ed&"
import script from "./RegattaLink.vue?vue&type=script&lang=js&"
export * from "./RegattaLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports